import Vancouver1 from "./../img/Travel/Vancouver/1.jpg";
import Vancouver2 from "./../img/Travel/Vancouver/2.jpg";

export const PLACES_NAMES = {
    "VANCOUVER": "Vancouver",
    "OTTAWA":    "Ottawa",
    "HALIFAX":   "Halifax",
    "INDIA":     "India",
    "AIR_MODE":  "Air Mode",
    "MEXICO":    "Mexico"
} 

export const TRAVEL_CATEGORIES = [
    PLACES_NAMES.VANCOUVER,
    PLACES_NAMES.OTTAWA,
    PLACES_NAMES.HALIFAX,
    PLACES_NAMES.INDIA,
    PLACES_NAMES.AIR_MODE,
    PLACES_NAMES.MEXICO
]

export const TRAVEL_PICS = [  
    [Vancouver1,Vancouver2],

]